module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0075.jpg?v=9c26bbfc";